<script setup>
import { useCentertelSession } from 'dashboard/composables/useCentertelSession';

const { isBlocked, isKicked, kickReason, centertelUrl } = useCentertelSession();
</script>

<template>
  <!-- SSO Block: login nativo bloqueado -->
  <Teleport to="body">
    <div
      v-if="isBlocked"
      class="fixed inset-0 z-[99999] flex flex-col items-center justify-center gap-4 bg-white/98 backdrop-blur-sm"
    >
      <div class="text-5xl">🔒</div>
      <h2 class="text-xl font-bold text-gray-800">Login pelo Portal</h2>
      <p class="text-sm text-gray-500 text-center max-w-[360px] leading-relaxed">
        O acesso ao atendimento deve ser feito pelo portal principal.
        Clique no botão abaixo para acessar.
      </p>
      <a
        :href="centertelUrl"
        class="inline-flex items-center gap-2 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-semibold transition-colors mt-2"
      >
        Acessar ennychat.com.br →
      </a>
      <p class="text-[11px] text-gray-400 mt-6">
        Caso o portal esteja indisponível, recarregue esta página para login direto.
      </p>
    </div>

    <!-- Session Kicked -->
    <div
      v-if="isKicked"
      class="fixed inset-0 z-[99999] flex flex-col items-center justify-center gap-4 bg-white/98 backdrop-blur-sm"
    >
      <div class="text-5xl">⚠️</div>
      <h2 class="text-xl font-bold text-gray-800">Sessão encerrada</h2>
      <p class="text-sm text-gray-500 text-center max-w-[360px] leading-relaxed">
        {{ kickReason }}
      </p>
      <a
        :href="centertelUrl"
        class="inline-flex items-center gap-2 px-8 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold transition-colors mt-2"
      >
        Voltar ao portal
      </a>
    </div>
  </Teleport>
</template>
